import React from "react";

import  { RutValidator }  from "adds/RutValidator.js"
import {
          Box,
          Typography,
          Grid,
          Divider
        } from '@mui/material';


class ContribuyenteVista extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data:null,
      html:{
        box_padding:0,
        variant:'overline'
      }
    };
  }



  componentDidUpdate(prevProps){
    let prop_name = 'contribuyente'
    
    const matches = (obj, source) =>
      Object.keys(source).every(key => obj.hasOwnProperty(key) && obj[key] === source[key]);
    
    if( this.props[prop_name] && prevProps[prop_name] &&
        !matches(this.props[prop_name], prevProps[prop_name]) ){

        this.componentDidMount();
    }
  }
  componentDidMount(){
    const html = this.state.html;
    // console.log('comunas', this.props.comunas)
    // console.log('contribuyente', this.props.contribuyente)
    // console.log('match',this.props.comunas.find(o => o.id === this.props.contribuyente.comuna_id))
    if('compact' in this.props && this.props.compact === true){
      html.box_padding= 0;
      html.variant='caption';
    }
    this.setState(prevState => ({
        data: this.props.contribuyente,
        html: html
    }),()=>{
    });
  
  }
  
  render() {
    return (
        <Box>
          { this.state.data &&
          <Box>

            <Box p={this.state.html.box_padding}>
              <Typography variant='h6'>{this.props.titulo}</Typography>
            </Box>

            <Box p={this.state.html.box_padding}>
              <Typography variant={this.state.html.variant} color='textSecondary'>Año proceso</Typography>
              <Box>{this.state.data.agno_proceso}</Box>
            </Box>
            <Grid container>
              <Grid item sm={12} md={6}>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Email</Typography>
                  <Box>{this.state.data.email}</Box>
                </Box>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Rut</Typography>
                  <Box>{this.state.data.rut?RutValidator.format(this.state.data.rut):''}</Box>
                </Box>
              </Grid>
              <Grid item sm={12} md={6}>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Teléfono</Typography>
                  <Box>{this.state.data.telefono}</Box>
                </Box>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Tipo de contribuyente</Typography>
                  <Box>{this.state.data.tipo}</Box>
                </Box>
              </Grid>
            </Grid>
            <Divider />
            <Grid container>
              <Grid item sm={12} md={6}>
                { this.state.data.tipo === 'Persona Natural' &&
                <Box>
                  <Box p={this.state.html.box_padding}>
                    <Typography variant={this.state.html.variant} color='textSecondary'>Nombres</Typography>
                    <Box>{this.state.data.nombres}</Box>
                  </Box>
                  <Box p={this.state.html.box_padding}>
                    <Typography variant={this.state.html.variant} color='textSecondary'>Apellido Paterno</Typography>
                    <Box>{this.state.data.apellido_paterno}</Box>
                  </Box>
                  <Box p={this.state.html.box_padding}>
                    <Typography variant={this.state.html.variant} color='textSecondary'>Apellido Materno</Typography>
                    <Box>{this.state.data.apellido_materno}</Box>
                  </Box>
                </Box>
                }
                { this.state.data.tipo === 'Empresa' &&
                <Box>
                  <Box p={this.state.html.box_padding}>
                    <Typography variant={this.state.html.variant} color='textSecondary'>Nombre Empresa</Typography>
                    <Box>{this.state.data.nombre_empresa}</Box>
                  </Box>    
                  <Box p={this.state.html.box_padding}>
                    <Typography variant={this.state.html.variant} color='textSecondary'>Giro Empresa</Typography>
                    <Box>{this.state.data.giro_empresa}</Box>
                  </Box>
                  
                </Box>
                }

              </Grid>
              <Grid item sm={12} md={6}>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Calle</Typography>
                  <Box>{this.state.data.direccion_calle}</Box>
                </Box>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Número</Typography>
                  <Box>{this.state.data.direccion_numero}</Box>
                </Box>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Departamento</Typography>
                  <Box>{this.state.data.direccion_unidad}</Box>
                </Box>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Población</Typography>
                  <Box>{this.state.data.direccion_poblacion}</Box>
                </Box>
                <Box p={this.state.html.box_padding}>
                  <Typography variant={this.state.html.variant} color='textSecondary'>Comuna</Typography>
                  <Box> 
                    { 'comunas' in this.props && 
                      this.props.comunas.length>0 && 
                      this.props.comunas.find(o => o.id === this.state.data.comuna_id) ? 
                      this.props.comunas.find(o => o.id === this.state.data.comuna_id).nombre:"-"
                    }
                  </Box>
                </Box>
              </Grid>
            </Grid>
            
          </Box>
          }
        </Box>
          
    );
  }
}

export default ContribuyenteVista;
